'use strict';

var util = angular.module('gymsystem.util');

util.directive('productSearch', ['server', '$rootScope', '$timeout', '$parse', '$filter', function(server, $rootScope, $timeout, $parse, $filter) {
    return {
        scope: {
            hideHeader: '=?',
            hideCategories: '=?'
        },
        restrict: 'AE',
        templateUrl: '/components/product/category/search.html',
        link: function($scope, $element, $attrs) {
            $scope.$on('$destroy', $scope.$parent.$watch($attrs.products, function(value) {
                $scope.products = value;
                $scope.allProducts = $scope.products.slice();
                $scope.allProducts.push.apply($scope.allProducts, $scope.trainingcards);
            }, true));
            $scope.$on('$destroy', $scope.$parent.$watch($attrs.trainingCards, function(value) {
                $scope.trainingcards = value;
                $scope.allProducts = $scope.products.slice();
                $scope.allProducts.push.apply($scope.allProducts, $scope.trainingcards);
            }, true));
            var onScreenKeyboard = $attrs.onScreenKeyboard == 'true';

            var callbackFn;
            if($attrs.onSelect) {
                callbackFn = $parse($attrs.onSelect);
            }
            $scope.chooseProduct = function(product) {
                if(callbackFn) {
                    callbackFn($scope.$parent, {$value: product});
                }
            };

            $scope.showKeyboard = function(event) {
                if (onScreenKeyboard) {
                    $(event.target).prop('readonly', true).numpad({
                        type: 'alphabetical',
                        textClear: $filter('translate')('Clear'),
                        textCancel: $filter('translate')('Cancel')
                    });
                }
            };

            $scope.mode = null;
            $scope.levels = [];
            $scope.products = [];
            $scope.trainingcards = [];
            $scope.allProducts = [];
            $scope.data = {
                searchText: '',
                activeCategory: null
            };
            $scope.elLine = [];
            var categories = [];

            function buildLevel() {
                var pid = null;
                $scope.levels.length = 0;
                if($scope.data.activeCategory) {
                    pid = $scope.data.activeCategory.id;
                }

                function filterByParent(c) {
                    return !c.removed && c.parent_id == pid;
                }
                for(var i=0;i<20;i++) {
                    var lvl = categories.filter(filterByParent);
                    if(lvl.length) {
                        $scope.levels.unshift(lvl.sort(function(a, b) {
                            if(a.order < b.order) {return -1;}
                            if(a.order > b.order) {return 1;}
                            return 0;
                        }));
                    }

                    if(pid) {
                        var p = _.findWhere(categories, {id:pid});
                        pid = p.parent_id;
                    } else {
                        break;
                    }
                }
            }

            server.post2('/api/trainingcard/category/get').then(function(result) {
                categories = result;
                buildLevel();
            });

            $scope.chooseCategory = function(category) {
                if (!category) {
                    // show all products
                    $scope.data.activeCategory = undefined;
                    $scope.data.searchText = '';
                } else if($scope.data.activeCategory == category) {
                    $scope.data.activeCategory = _.findWhere(categories, {id:category.parent_id});
                } else {
                    $scope.data.activeCategory = category;
                }
                buildLevel();
            };
            $scope.isActive = function(category) {
                var active = $scope.data.activeCategory;
                if(!active) {return false;}
                while(true) {
                    if(active === category) {return true;}
                    if(!active.parent_id) {break;}
                    active = _.findWhere(categories, {id:active.parent_id});
                }
                return false;
            };

            $scope.getProducts = function() {
                if(!$scope.data.activeCategory || $scope.data.searchText) {return $scope.allProducts;}

                var groups = {};
                groups[$scope.data.activeCategory.id] = true;

                function getChildren(pid) {
                    return categories.filter(function(c) {return !c.removed && c.parent_id == pid;});
                }
                function mark(category) {
                    if(groups[category.id]) {return;}
                    groups[category.id] = true;
                    getChildren(category.id).forEach(mark);
                }
                getChildren($scope.data.activeCategory.id).forEach(mark);

                return $scope.allProducts.filter(function(p) {
                    return groups[p.product_category_id];
                });
            };

            $scope.shift = function(index, shift) {
                var el = $scope.elLine[index];
                var boxWidth = $scope.elBox.clientWidth - 60;  // -60px margin
                var left = 0;

                var needLeft = (-Number.parseInt(el.style.left)) + boxWidth * shift;
                if(needLeft < 0) {needLeft = 0;}
                var maxShift = el.children[el.children.length-1].offsetLeft; // - boxWidth; // + el.children[el.children.length-1].clientHeight;

                for(var i=0;i<el.children.length;i++) {
                    var box = el.children[i];
                    if(left >= maxShift || box.offsetLeft >= needLeft) {break;}
                    left = box.offsetLeft;
                }
                el.style.left = (-left) + 'px';
            };

        }
    };
}]);
